/* eslint-disable no-undef */
import './scss/compare.scss';
import _debounce from 'underscore/modules/debounce';
import CurrencyFormatter from '../utils/currency-formatter-lib';
import Client from '../configurator_2/client/client';
import { getLeadTime, getEstimatedMonth } from '../utils/lead-time-helper';
import Equalizer from '../utils/equalizer';

export default class CarCompare {
    constructor(el) {
        this.el = el;
        this.dataUrl = el.dataset.apiUrl;
        this.compareBaseModalComponent = el.querySelector('.car-compare-base-modal');
        this.chooseVehicleContainer = el.querySelector('.choose-vehicle--inner');
        this.compareLinks = el.querySelectorAll('.compare-button');
        this.chooseVehicleColumns = el.querySelectorAll('.choose-vehicle--column');
        this.compareModalClose = this.compareBaseModalComponent.querySelector('.modal-close');
        this.modalBackdrop = this.compareBaseModalComponent.querySelector('.model-backdrop');
        this.compareSelectorLink = this.compareBaseModalComponent.querySelector('.compare-selector-link');
        this.compareItems = {
            vehicleChooseComponent: this.el.querySelectorAll('.selected-container'),
            compareBaseModal: this.el.querySelector('#car-compare-base-modal'),
            vehicleComparisonTable: this.el.querySelector('#vehicle-comparison-table'),
            savedCarsComponent: this.el.querySelector('#saved-cars'),
        };
        this.addSelection = this.compareBaseModalComponent.querySelector('#addSelection');
        this.addSavedSelection = this.compareBaseModalComponent.querySelector('#addSavedSelection');
        this.toggleWrapper = el.querySelector('.specification-toggle-wrapper');
        this.differenceToggle = el.querySelector('#toggle_checkbox');
        this.specDescription = el.querySelector('.specification-description');
        this.carData = {};
        this.featureGroups = [];
        this.selectedGradeData = {};
        this.clickDataIndex = '';
        this.gradeDropdownValue = '';
        this.carDropdownValue = '';
        this.gradeData = {};
        this.filteredCars = [];
        this.savedCarsAdded = [];
        this.addedCars = [];
        this.formatter = new CurrencyFormatter();
        this.client = new Client(this);
        this.scrollAdjuster = el.querySelector('.scroll-adjuster');
        this.scrollArea = el.querySelector('.scroll-area');
        this.savedCarData = window.HONDA.SaveForLater.saveForLater.saved.flatMap((model) => model.data);

        this.compareItemsTemplates = {
            vehicleChooseComponent: _.template(el.querySelector('#choose-vehicle-template').innerHTML.replaceAll('\\', '')),
            compareBaseModal: _.template(el.querySelector('#car-compare-base-modal-template').innerHTML.replaceAll('\\', '')),
            vehicleComparisonTable: _.template(el.querySelector('#vehicle-comparison-table-template').innerHTML.replaceAll('\\', '')),
            savedCarsComponent: _.template(el.querySelector('#saved-cars-template').innerHTML.replaceAll('\\', '')),
            carPriceComponent: _.template(el.querySelector('#car-pricing-template').innerHTML.replaceAll('\\', '')),
            deliveryDateComponent: _.template(el.querySelector('#delivery-date-template').innerHTML.replaceAll('\\', '')),
        };

        this.init();
    }

    init() {
        this.getCarsData();
        this.bind();
    }

    bind() {
        this.compareLinks.forEach((item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                this.compareBaseModalComponent.classList.remove('hide');
                this.getCompareItemSelectModal();
                this.clickDataIndex = event.target.dataset.index;
                const savedCars = this.getSavedCarsArray();

                if (this.savedCarData.length === 0 || savedCars.length === 0) {
                    this.compareBaseModalComponent.querySelector('#saved-car-selection').classList.add('disabled');
                }

                if (this.savedCarData.length === 0) {
                    document.querySelector('.no-saved-item-alert').classList.remove('hide');
                } else {
                    document.querySelector('.no-saved-item-alert').classList.add('hide');
                }
                document.documentElement.classList.add('modal-active');
            });
        });

        this.modalBackdrop.addEventListener('click', (e) => {
            if (e.target && e.target.matches('.model-backdrop')) {
                e.preventDefault();
                this.compareBaseModalComponent.classList.add('hide');
                document.documentElement.classList.remove('modal-active');
            }
        });

        this.compareModalClose.addEventListener('click', (e) => {
            e.preventDefault();
            this.compareBaseModalComponent.classList.add('hide');
            document.documentElement.classList.remove('modal-active');
        });
        this.compareBaseModalComponent.addEventListener('change', (e) => this.getDropdownIndex(e));
        this.compareBaseModalComponent.addEventListener('click', (e) => {
            this.showCarSelectorDropdown(e);
            this.addSavedConfigCars(e);
            this.showSavedCars(e);
        });

        this.compareItems.vehicleComparisonTable.addEventListener('click', (e) => {
            this.accordionHandler(e);
        });

        this.chooseVehicleContainer.addEventListener('click', (e) => {
            this.removeSelectedItem(e);
        });

        this.differenceToggle.addEventListener('change', (e) => {
            this.checkDifferences(e);
        });

        document.addEventListener('click', (e) => {
            this.addModelSelected(e);
            this.setHeightToCards();
        });

        this.onResize();
    }

    onResize() {
        window.addEventListener('resize', _debounce(() => {
            this.setHeightToCards();
        }, 200))
    }

    // eslint-disable-next-line class-methods-use-this
    isEmptyObject(obj) {
        // eslint-disable-next-line no-restricted-syntax
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }
        return true;
    }

    setStickyClass(addedCars) {
        const thresholdValue = '500px';
        const handleScroll = _debounce(() => {
            const stickyPoint = this.scrollAdjuster.offsetTop + 200;
            const scrollPosition = window.scrollY;

            if (scrollPosition >= stickyPoint && addedCars.length > 1) {
                if (!this.scrollArea.classList.contains('scroll-container')) {
                    this.scrollAdjuster.style.height = thresholdValue;
                    this.scrollArea.classList.add('scroll-container');
                    Equalizer.equalizeItems(this.el.querySelectorAll('.vehicle-title'));
                }
            } else if (this.scrollArea.classList.contains('scroll-container')) {
                this.scrollAdjuster.style.height = 0;
                this.scrollArea.classList.remove('scroll-container');
                Equalizer.equalizeItems(this.el.querySelectorAll('.vehicle-title'));
            }
        }, 30);

        document.addEventListener('scroll', handleScroll);
    }

    getCarsData() {
        this.getData(this.dataUrl)
            .then((data) => {
                if (this.isEmptyObject(this.carData)) {
                    this.carData = data.carsData;
                    this.featureGroups = data.groups;
                    this.getSavedCarFromExternal();
                }
                this.getSelectModelItems();
            })
            .catch((error) => {
                console.error("Error in anotherMethod:", error);
            });
    }

    getCompareItemSelectModal() {
        const compareBaseModalBlock = this.compareItems.compareBaseModal.textContent ?? '';
        this.compareItems.compareBaseModal.innerHTML = this.compareItemsTemplates.compareBaseModal({ compareBaseModalBlock });

        if (this.carData) {
            this.getSelectModelItems();
        }
    }

    getSelectModelItems() {
        const selectCarModel = this.compareBaseModalComponent.querySelector('#selectCarModel');

        if (!selectCarModel) {
            return;
        }

        this.carData.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.name;
            option.textContent = item.name;
            selectCarModel.appendChild(option);
        });
    }

    getSelectGradeItems() {
        const selectCarGrade = this.compareBaseModalComponent.querySelector('#selectCarGrade');
        if (!selectCarGrade) {
            return;
        }

        let carsArray = [];

        if (this.addedCars.length > 0) {
            carsArray = this.getRemainingCars(this.addedCars);
        } else {
            carsArray = this.carData;
        }

        carsArray.forEach((item) => {
            if (item.name === this.carDropdownValue) {
                this.selectedGradeData = item.cars;
            }
        });

        if (!this.selectedGradeData) {
            return;
        }

        this.setGradeSelectBlank();

        this.selectedGradeData.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.code;
            option.textContent = item.gradeName;
            selectCarGrade.appendChild(option);
        });
    }

    setGradeSelectBlank() {
        const selectCarGrade = this.compareBaseModalComponent.querySelector('#selectCarGrade');
        selectCarGrade.innerHTML = '';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = 'Select a Grade';
        selectCarGrade.appendChild(defaultOption);
    }

    // eslint-disable-next-line class-methods-use-this
    getDropdownIndex(event) {
        const selectionButtons = this.compareBaseModalComponent?.querySelector('.select-model-button');
        if (event.target && event.target.id === 'selectCarModel') {
            this.carDropdownValue = event.target.value;

            if (event.target.value === '') {
                selectionButtons.classList.add('hide');
                this.setGradeSelectBlank();
            } else {
                this.getSelectGradeItems();
            }
        }

        if (event.target && event.target.id === 'selectCarGrade') {
            this.gradeDropdownValue = event.target.value;
            if (event.target.value === '') {
                selectionButtons.classList.add('hide');
            } else {
                this.showSelectionButtons(false);
            }
        }
    }

    showSelectionButtons(status) {
        const selectionButtons = this.compareBaseModalComponent?.querySelector('.select-model-button');
        if (status) {
            selectionButtons.querySelector('#addSelection').classList.add('hide');
            selectionButtons.querySelector('#addSavedSelection').classList.remove('hide');
        } else {
            selectionButtons.querySelector('#addSelection').classList.remove('hide');
            selectionButtons.querySelector('#addSavedSelection').classList.add('hide');
        }
        selectionButtons.classList.remove('hide');
    }

    getGradeData(value) {
        this.selectedGradeData.forEach((item) => {
            if (item.code === value) {
                this.gradeData = item;
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    addModelSelected(event) {
        if (event?.target && event?.target.id === 'addSelection') {
            event.preventDefault();
            this.getGradeData(this.gradeDropdownValue);

            this.compareItems.vehicleChooseComponent.forEach((item) => {
                if (item.id === this.clickDataIndex) {
                    item.parentNode.nextElementSibling?.classList.remove('disabled');
                    item.parentNode.querySelector('.choose-vehicle-container').classList.add('hide');
                    item.parentNode.classList.add('added');
                    item.parentNode.classList.remove('removed');
                    item.parentNode.classList.remove('saved-car');
                    this.addCarData(this.carData, this.gradeDropdownValue, event);
                    this.compareBaseModalComponent.classList.add('hide');
                }
            });
            document.documentElement.classList.remove('modal-active');
        }

        if (event?.target && event?.target.id === 'addSavedSelection') {
            event.preventDefault();
            const code = event.target.dataset.carCode;
            // eslint-disable-next-line prefer-destructuring
            const carMtoce = event.target.dataset.carMtoce;
            // eslint-disable-next-line prefer-destructuring
            const carUrl = event.target.dataset.carUrl;
            // eslint-disable-next-line prefer-destructuring
            const gradeEngineName = event.target.dataset.gradeEngineName;
            // eslint-disable-next-line prefer-destructuring
            const vehicleName = event.target.dataset.vehicleName;

            this.compareItems.vehicleChooseComponent.forEach((item) => {
                if (item.id === this.clickDataIndex) {
                    item.parentNode.nextElementSibling?.classList.remove('disabled');
                    item.parentNode.querySelector('.choose-vehicle-container').classList.add('hide');
                    item.parentNode.classList.add('added');
                    item.parentNode.classList.remove('removed');
                    item.parentNode.classList.add('saved-car');
                    // eslint-disable-next-line no-param-reassign
                    this.addCarData(this.carData, code, event, carMtoce, carUrl, gradeEngineName, vehicleName);
                    this.compareBaseModalComponent.classList.add('hide');
                }
            });
            document.documentElement.classList.remove('modal-active');
        }

        if (event?.target && event?.target.id === 'cancelSelection') {
            this.compareBaseModalComponent.classList.add('hide');
            document.documentElement.classList.remove('modal-active');
        }
    }

    getCarsSelected(addedCars) {
        if (!Array.isArray(addedCars)) {
            return [];
        }

        const filteredCarData = addedCars.map((carCode) => {
            const carModel = this.carData.find((model) => model.cars.some((car) => car.code === carCode));
            if (carModel) {
                const filteredCars = carModel.cars.filter((car) => car.code === carCode);
                return { ...carModel, cars: filteredCars };
            }
            return null;
        }).filter((carModel) => carModel !== null);

        return filteredCarData;
    }

    getRemainingCars(addedCars) {
        const filteredCarData = this.carData.map((carModel) => {
            const filteredCars = carModel.cars.filter((car) => !addedCars.includes(car.code));
            if (filteredCars.length > 0) {
                return { ...carModel, cars: filteredCars };
            }
            return null;
        }).filter((carModel) => carModel !== null);
        return filteredCarData;
    }

    // eslint-disable-next-line class-methods-use-this
    addCarData(carsData, gradeValue, event, carMtoce, carUrl, gradeEngineName, vehicleName, directTransfer) {
        carsData.forEach((carItem) => {
            // eslint-disable-next-line no-param-reassign, array-callback-return
            carItem.cars.filter((car) => {
                if (car.code === gradeValue) {
                    if (!this.addedCars.includes(car.code)) {
                        this.addedCars.push(car.code);
                        this.savedCarsAdded.push(`${car.gradeName}|${car.engineTDCode}`.trim().replaceAll(' ', ''));
                        this.getCarsSelected(this.addedCars);
                        this.getRemainingCars(this.addedCars);
                        this.filteredCars = this.getCarsSelected(this.addedCars);
                        const addedCars = this.filteredCars.flatMap((model) => model.cars);
                        const modelName = this.filteredCars.flatMap((model) => model.name);
                        if ((event?.target && event?.target.id === 'addSavedSelection') || directTransfer) {
                            // eslint-disable-next-line no-param-reassign
                            car.savedItem = true;
                            // eslint-disable-next-line no-param-reassign
                            car.mtoce = carMtoce || car.mtoce;
                            // eslint-disable-next-line no-param-reassign
                            car.configuratorPath = carUrl || car.configuratorPath;
                            // eslint-disable-next-line no-param-reassign
                            car.gradeEngineName = gradeEngineName || car.gradeName;
                            // eslint-disable-next-line no-param-reassign
                            car.vehicleName = vehicleName;
                        } else {
                            // eslint-disable-next-line no-param-reassign
                            car.savedItem = false;
                        }
                        this.getCompareTableSpecification(addedCars, modelName);
                        this.arrangeCompareItems();
                    }
                }
            });
        });
        this.setStickyClass(this.addedCars);
    }

    removeCarData(selectedValue, gradeEngineValue) {
        this.addedCars.forEach((item, index) => {
            if (item === selectedValue) {
                this.addedCars.splice(index, 1);
                this.getCarsSelected(this.addedCars);
                this.getRemainingCars(this.addedCars);
                this.filteredCars = this.getCarsSelected(this.addedCars);
                const addedCars = this.filteredCars.flatMap((model) => model.cars);
                const modelNames = this.filteredCars.flatMap((model) => model.name);
                this.getCompareTableSpecification(addedCars, modelNames);
                this.arrangeCompareItems();
                if (addedCars.length <= 1) {
                    this.scrollArea.classList.remove('scroll-container');
                    this.scrollAdjuster.style.height = 0;
                }
            }
        });
        this.savedCarsAdded.forEach((item, index) => {
            if (item === gradeEngineValue.trim().replaceAll(' ', '')) {
                this.savedCarsAdded.splice(index, 1);
            }
        });
        this.setStickyClass(this.addedCars);
    }

    arrangeCompareItems() {
        const addedCars = this.filteredCars.flatMap((model) => model.cars);
        const modelName = this.filteredCars.flatMap((model) => model.name);
        this.compareItems.vehicleChooseComponent.innerHTML = '';

        this.chooseVehicleColumns.forEach((column, index) => {
            const selectedContainer = column.querySelector('.selected-container');

            if (index < addedCars.length) {
                column.classList.add('added');
                column.classList.remove('removed');
                if (addedCars[index].savedItem) {
                    selectedContainer.parentNode.classList.add('saved-car');
                } else {
                    selectedContainer.parentNode.classList.remove('saved-car');
                }

                selectedContainer.innerHTML = this.compareItemsTemplates.vehicleChooseComponent({
                    modelName: modelName[index],
                    data: addedCars[index],
                    parentValue: this.carDropdownValue,
                });

                const priceItem = selectedContainer.querySelector('.car-price');
                const deliveryDate = selectedContainer.querySelector('.estimate-delivery');

                const ids = addedCars[index].savedItem ? addedCars[index].mtoce : addedCars[index].mto;

                this.client.getCarPricing(ids)
                    .then((priceData) => {
                        if (priceData && priceData.data && priceData.data[0].price) {
                            priceItem.innerHTML = this.compareItemsTemplates.carPriceComponent({
                                carPrice: this.formatter.to(priceData.data[0].price),
                            });
                            const leadTime = addedCars[index].savedItem ? priceData.data[0].c_bundledProducts[0].c_dealerArrivalDate : getLeadTime(priceData.data[0]);
                            const dealerArrivalDate = getEstimatedMonth(leadTime);

                            deliveryDate.innerHTML = this.compareItemsTemplates.deliveryDateComponent({
                                deliveryDate: dealerArrivalDate,
                            });
                            Equalizer.equalizeItems(this.el.querySelectorAll('.estimate-delivery'));
                        } else {
                            const priceStringtoInteger = parseInt(addedCars[index].defaultPrice, 10);
                            priceItem.innerHTML = this.compareItemsTemplates.carPriceComponent({
                                carPrice: this.formatter.to(priceStringtoInteger),
                            });

                            deliveryDate.innerHTML = '';
                            Equalizer.equalizeItems(this.el.querySelectorAll('.estimate-delivery'));
                        }
                    })
                    .catch(() => {
                        const priceStringtoInteger = parseInt(addedCars[index].defaultPrice, 10);
                        priceItem.innerHTML = this.compareItemsTemplates.carPriceComponent({
                            carPrice: this.formatter.to(priceStringtoInteger),
                        });

                        deliveryDate.innerHTML = '';
                    });

                selectedContainer.nextElementSibling.classList.add('hide');
            } else {
                column.classList.remove('added');
                column.classList.add('removed');
                column.classList.remove('saved-car');
                const removedItem = column.classList.contains('removed');
                selectedContainer.innerHTML = '';
                selectedContainer.nextElementSibling.classList.remove('hide');
                // eslint-disable-next-line default-case
                switch (index) {
                case 0:
                    if (removedItem) {
                        column.nextElementSibling.classList.add('disabled');
                    }
                    break;
                case 1:
                    if (removedItem) {
                        column.nextElementSibling.classList.add('disabled');
                    }
                    break;
                }
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    removeSelectedItem(event) {
        if (event.target && event.target.className === 'remove-button') {
            event.preventDefault();
            // eslint-disable-next-line no-param-reassign
            const selectedVal = event.target.dataset.selectedValue;
            const gradeEngineValue = event.target.dataset.gradeEngine;
            const parentElement = event.target.parentNode.parentNode.parentNode;
            parentElement.nextElementSibling.classList.remove('hide');
            parentElement.parentNode.classList.remove('added');
            parentElement.parentNode.classList.add('removed');
            event.target.parentNode.parentNode.remove();
            this.removeCarData(selectedVal, gradeEngineValue);
        }
    }

    showCarSelectorDropdown(e) {
        const dropdownContainer = this.compareBaseModalComponent?.querySelector('.select-model-wrapper');
        const compareModalLinks = this.compareBaseModalComponent?.querySelector('.compare-modal-inner');
        if (!dropdownContainer) {
            return;
        }

        if (e.target && e.target.matches('#new-selection')) {
            e.preventDefault();
            dropdownContainer.classList.remove('hide');
            compareModalLinks.classList.add('hide');
        }
    }

    getMatchedCars() {
        const carData = this.carData.flatMap((model) => model.cars);
        const matchedCarData = this.savedCarData.map((savedCar) => {
            const carByMtoce = carData.find((car) => savedCar?.mtoce?.trim().startsWith(car?.mto?.trim()));
            if (!carByMtoce) {
                const carByGradeEngine = carData.find((car) => `${car.gradeName}|${car.engineTDCode}`.trim().replaceAll(' ', '') === savedCar.gradeEngineCode.trim().replaceAll(' ', ''));
                return carByGradeEngine || null;
            }
            return carByMtoce;
        }).filter((car) => car !== null);

        if (this.savedCarsAdded.length > 0) {
            return matchedCarData.filter((item) => !this.savedCarsAdded.includes(`${item.gradeName}|${item.engineTDCode}`.trim().replaceAll(' ', '')));
        }
        return matchedCarData;
    }

    getSavedCarsArray() {
        // eslint-disable-next-line prefer-destructuring
        const savedCarsAdded = this.savedCarsAdded;

        const savedCars = this.getMatchedCars().map((car) => {
            const carByMtoce = this.savedCarData.find((savedCar) => savedCar?.mtoce?.trim().startsWith(car?.mto?.trim()));
            if (!carByMtoce) {
                const carByGradeEngine = this.savedCarData.find((savedCar) => `${car.gradeName}|${car.engineTDCode}`.trim().replaceAll(' ', '') === savedCar.gradeEngineCode.trim().replaceAll(' ', ''));
                return carByGradeEngine || null;
            }
            return carByMtoce;
        }).filter((car) => car !== null);

        if (savedCarsAdded.length > 0) {
            return savedCars.filter((item) => {
                // eslint-disable-next-line prefer-destructuring
                const gradeEngineCode = item.gradeEngineCode;
                return !savedCarsAdded.some((addedCode) => addedCode.trim().replaceAll(' ', '') === gradeEngineCode.trim().replaceAll(' ', ''));
            });
        }
        return savedCars;
    }

    showSavedCars(e) {
        const savedCarsContainer = this.compareBaseModalComponent?.querySelector('.saved-car-container');
        const compareModalLinks = this.compareBaseModalComponent?.querySelector('.compare-modal-inner');

        if (e.target && e.target.matches('#saved-car-selection') && !e.target.matches('.disabled')) {
            e.preventDefault();
            const matchedCarData = this.getMatchedCars();
            const savedCars = this.getSavedCarsArray();
            savedCarsContainer.classList.remove('hide');
            compareModalLinks.classList.add('hide');
            savedCarsContainer.innerHTML = this.compareItemsTemplates.savedCarsComponent({ carData: matchedCarData, savedCarData: savedCars });

            const savedItems = savedCarsContainer.querySelectorAll('.saved-car-link');

            savedItems?.forEach((item, index) => {
                const priceItem = item.querySelector('.car-price');

                this.client.getCarPricing(savedCars[index].mtoce)
                    .then((priceData) => {
                        if (priceData && priceData.data && priceData.data[0].price) {
                            priceItem.innerHTML = this.compareItemsTemplates.carPriceComponent({
                                carPrice: this.formatter.to(priceData.data[0].price),
                            });
                        } else {
                            const priceStringtoInteger = parseInt(matchedCarData[index].defaultPrice, 10);
                            priceItem.innerHTML = this.compareItemsTemplates.carPriceComponent({
                                carPrice: this.formatter.to(priceStringtoInteger),
                            });
                        }
                    })
                    .catch(() => {
                        const priceStringtoInteger = parseInt(matchedCarData[index].defaultPrice, 10);
                        priceItem.innerHTML = this.compareItemsTemplates.carPriceComponent({
                            carPrice: this.formatter.to(priceStringtoInteger),
                        });
                    });
            });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    addSavedConfigCars(e) {
        if (e.target && e.target.matches('.saved-car-link')) {
            e.preventDefault();
            const code = e.target.dataset.carCode;
            // eslint-disable-next-line prefer-destructuring
            const carMtoce = e.target.dataset.carMtoce;
            // eslint-disable-next-line prefer-destructuring
            const carUrl = e.target.dataset.carUrl;
            // eslint-disable-next-line prefer-destructuring
            const gradeEngineName = e.target.dataset.gradeEngineName;
            // eslint-disable-next-line prefer-destructuring
            const vehicleName = e.target.dataset.vehicleName;
            document.querySelectorAll('.saved-car-link').forEach((item) => {
                item.classList.remove('active');
            });
            e.target.classList.add('active');
            this.showSelectionButtons(true);
            e.target.parentNode.nextElementSibling.nextElementSibling.querySelector('#addSavedSelection').dataset.carCode = code;
            e.target.parentNode.nextElementSibling.nextElementSibling.querySelector('#addSavedSelection').dataset.carMtoce = carMtoce;
            e.target.parentNode.nextElementSibling.nextElementSibling.querySelector('#addSavedSelection').dataset.carUrl = carUrl;
            e.target.parentNode.nextElementSibling.nextElementSibling.querySelector('#addSavedSelection').dataset.gradeEngineName = gradeEngineName;
            e.target.parentNode.nextElementSibling.nextElementSibling.querySelector('#addSavedSelection').dataset.vehicleName = vehicleName;
        }
    }

    // eslint-disable-next-line class-methods-use-this
    filterMatchingSpecsAcrossCars(data) {
        const specsArrays = data.map((car) => car.specs);
        const allKeys = Array.from(new Set(specsArrays.flatMap((specs) => Object.keys(specs))));

        const matchingSpecs = allKeys.filter((key) => {
            const values = specsArrays.map((specs) => specs[key]?.value);
            return values.every((value) => value === values[0]);
        });

        return data.map((car) => {
            const filteredSpecs = Object.fromEntries(
                Object.entries(car.specs).filter(([key]) => !matchingSpecs.includes(key)),
            );
            return { ...car, specs: filteredSpecs };
        });
    }

    // eslint-disable-next-line class-methods-use-this
    checkDifferences(event) {
        if (event.target.checked) {
            const addedCars = this.filteredCars.flatMap((model) => model.cars);
            const modelNames = this.filteredCars.flatMap((model) => model.name);
            if (addedCars.length > 1) {
                const filteredData = this.filterMatchingSpecsAcrossCars(addedCars);
                this.getCompareTableSpecification(filteredData, modelNames);
            }
        } else {
            const addedCars = this.filteredCars.flatMap((model) => model.cars);
            const modelNames = this.filteredCars.flatMap((model) => model.name);
            this.getCompareTableSpecification(addedCars, modelNames);
        }
    }

    // eslint-disable-next-line class-methods-use-this
    accordionHandler(event) {
        if (event.target && event.target.classList.contains('header')) {
            event.preventDefault();
            const currentContent = event.target.nextElementSibling;
            if (currentContent) {
                event.target.classList.toggle('inactive');
                currentContent.classList.toggle('hide');
            }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    async getData(url) {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // eslint-disable-next-line no-return-await
        return await response.json();
    }

    // eslint-disable-next-line class-methods-use-this
    getSavedCarFromExternal() {
        const carSaveUrl = new URL(window.location.href.replace(/#/g, '?'));
        const carId = carSaveUrl.searchParams.get('carId');

        if (carId) {
            const getCarWithId = this.savedCarData.find((car) => car.id === carId);
            const carMtoce = getCarWithId?.mtoce;
            const carUrl = getCarWithId?.carLongUrl;
            const gradeEngineName = getCarWithId?.gradeEngine.replace('|', ' ');
            const vehicle = getCarWithId?.vehicleName;
            const matchedCars = this.getMatchedCars();
            const savedCarByMtoce = matchedCars?.find((car) => getCarWithId?.mtoce?.trim().startsWith(car?.mto?.trim()));
            if (savedCarByMtoce) {
                this.compareItems.vehicleChooseComponent.forEach((item, index) => {
                    if (index === 0) {
                        item.parentNode.nextElementSibling?.classList.remove('disabled');
                        item.parentNode.querySelector('.choose-vehicle-container').classList.add('hide');
                        item.parentNode.classList.add('added');
                        item.parentNode.classList.remove('removed');
                        item.parentNode.classList.add('saved-car');
                        // eslint-disable-next-line no-param-reassign
                        this.addCarData(this.carData, savedCarByMtoce.code, event, carMtoce, carUrl, gradeEngineName, vehicle, true);
                    }
                });
            }
        }
    }

    getCompareTableSpecification(addedCars, modelNames) {
        if (addedCars.length === 0) {
            this.specDescription.classList.remove('hide');
            this.compareItems.vehicleComparisonTable.innerHTML = '';
        } else {
            this.specDescription.classList.add('hide');
            this.compareItems.vehicleComparisonTable.innerHTML = this.compareItemsTemplates.vehicleComparisonTable({ modelName: modelNames, carData: addedCars, groupData: this.featureGroups });
        }

        if (addedCars.length > 1) {
            this.toggleWrapper.classList.remove('hide');
            const compareTableContainer = document.querySelectorAll('.compare-table-container');
            this.setHeightToColumns(compareTableContainer);
            document.addEventListener('resize', _debounce(() => {
                this.setHeightToColumns(compareTableContainer);
            }, 10, true));
        } else {
            this.toggleWrapper.classList.add('hide');
            this.toggleWrapper.querySelector('#toggle_checkbox').checked = false;
        }
    }

    setHeightToCards() {
        Equalizer.equalizeItems(this.el.querySelectorAll('.vehicle-title'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.vehicle-feature'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.estimate-delivery'));
    }


    setHeightToColumns(selector) {
        selector.forEach((parent) => {
            const childs = parent.querySelectorAll('.compare-table');
            const numberOfColumns = childs[0].querySelectorAll('.compare-data').length;

            // eslint-disable-next-line no-plusplus
            for (let columnIndex = 0; columnIndex < numberOfColumns; columnIndex++) {
                const columnNodes = [];
                childs.forEach((subChild) => {
                    const node = subChild.querySelectorAll('.compare-data')[columnIndex];
                    if (node) columnNodes.push(node);
                });

                if (columnNodes.length > 0) {
                    this.setEqualHeight(columnNodes);
                }
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    setEqualHeight(selector) {
        let maxHeight = 0;

        selector.forEach((element) => {
            // eslint-disable-next-line no-param-reassign
            element.style.height = 'auto';

            const elementHeight = element.offsetHeight;

            if (elementHeight > maxHeight) {
                maxHeight = elementHeight;
            }
        });
        selector.forEach((element) => {
            // eslint-disable-next-line no-param-reassign
            element.style.height = `${maxHeight}px`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.compare--container').forEach((el) => (el.classList.contains('load') ? new CarCompare(el) : null));
});
